import { Dispatch, SetStateAction, FC, memo } from 'react'
import { useDisclosure } from '@chakra-ui/react'

import { ActivityType } from 'Activities/types'
import { FilterTemplate } from 'components'

import FrequencieActivitiesTypesFilterForm from './components/FrequencieActivitiesTypesFilterForm'
import FrequencieActivitiesFilterFeedbacks from './components/FrequencieActivitiesFilterFeedbacks'

export type Props = {
  activitiesTypes: ActivityType[]
  title?: string
  description?: string
  filter: any
  setFilter: Dispatch<SetStateAction<any>>
}

const FrequencieActivitiesTypesFilterTemplate: FC<Props> = ({
  activitiesTypes,
  title = 'Selecione os tipos de atividades para filtragem',
  description,
  setFilter,
  filter,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  return (
    <FilterTemplate
      title={title}
      description={description}
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      content={
        <FrequencieActivitiesTypesFilterForm onClose={onClose} activitiesTypes={activitiesTypes} filter={filter} setFilter={setFilter} />
      }
      contentWhenClosed={<FrequencieActivitiesFilterFeedbacks onClose={onClose} filter={filter} setFilter={setFilter} />}
    />
  )
}

export default memo(FrequencieActivitiesTypesFilterTemplate)
